module.exports = __webpack_public_path__ + "img/wps2.d2607f89.png";